<template>
  <div class="root-container">
    <div class="weather-wrap">
      <div class="top-wrap">
        <span class="city-name">青岛</span>
        <div class="info">
          <van-icon :name="weatherIcon" />
          <div class="temp">
            <span>{{ nowData.temp }}°</span>
            <span>{{ nowData.text }}</span>
          </div>
          <div class="warning">
            <span v-if="warningDatas.length > 0" class="type-name">{{ warningDatas[0].typeName }}</span>
            <span class="aqi-name" :style="{color:getLevelColor(airData.aqi)}">{{ airData.category }}</span>
          </div>
        </div>
        <span class="tip">{{ popText }}</span>
      </div>
      <div class="line" />
      <div class="bottom-wrap">
        <div v-for="(item, index) in dailyDatas" :key="index" class="item">
          <span>{{ getDayTitle(index) }}</span>
          <van-icon :name="getWeatherIconByCode(item.iconDay)" />
          <span>{{ item.tempMin }}°/{{ item.tempMax }}°</span>
          <span v-if="false">良</span>
        </div>
      </div>
    </div>
    <div class="news-wrap">
      <span class="title">安全头条</span>
      <div v-for="item in newsDatas" :key="item.id" class="item">
        <span class="title">{{ item.title }}</span>
        <van-image
          :src="item.img"
          radius="8"
          width="110"
          height="55"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getWeatherNow, getWeatherDays, getWeatherHours, getAirNow, getWarningNow } from '@/api/weather_hefeng.js'
export default {
  name: 'Home',
  data() {
    return {
      nowData: {}, // 实时天气数据
      dailyDatas: [], // 逐天数据（3天）
      airData: {}, // 实时空气质量数据
      warningDatas: [], // 灾害预警
      hourlyDatas: [], // 逐小时天气数据(24小时)
      weatherIcon: '', // 天气icon路径
      popText: '', // 降水概率说明
      newsDatas: [
        {
          id: 1,
          title: '[特别关注]台风来了怎么办',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 2,
          title: '[安全指南]雨天配送安全指南',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 3,
          title: '[漫说安全]商家出餐慢，我该怎么办',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 4,
          title:
            '[漫说安全]商家出餐慢，我该怎么办商家出餐慢，我该怎么办商家出餐慢，我该怎么办商家出餐慢，我该怎么办',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 5,
          title: '[漫说安全]商家出餐慢，我该怎么办',
          img: require('/static/img/weather_bg_small.png')
        },
        {
          id: 6,
          title: '[漫说安全]商家出餐慢，我该怎么办',
          img: require('/static/img/weather_bg_small.png')
        }
      ]
    }
  },
  created() {
    this.getWeatherNow()
    this.getWeather3Days()
    this.getAirNow()
    this.getWarningNow()
    this.getPop2Hours()
  },
  methods: {
    // 实时天气
    getWeatherNow() {
      getWeatherNow().then((res) => {
        this.nowData = res.now || {}
        this.weatherIcon = this.getWeatherIconByCode(this.nowData.icon)
      })
    },
    // 逐3天天气
    getWeather3Days() {
      getWeatherDays(3).then((res) => {
        this.dailyDatas = res.daily || []
      })
    },
    // 空气质量
    getAirNow() {
      getAirNow().then((res) => {
        this.airData = res.now || {}
      })
    },
    // 灾害预警
    getWarningNow() {
      getWarningNow().then(res => {
        this.warningData = res.warning || []
      })
    },
    // 未来两小时降水概率
    getPop2Hours() {
      getWeatherHours(24).then(res => {
        this.hourlyDatas = res.hourly || []
        // 这里只取未来两小时数据
        if (this.hourlyDatas.length >= 2) {
          const firstData = this.hourlyDatas[0]
          const secondData = this.hourlyDatas[1]
          const firstPop = firstData.pop || '0'
          const secondPop = secondData.pop || '0'
          const firstPop_int = parseInt(firstPop)
          const secondPop_int = parseInt(secondPop)
          if (firstPop_int >= 30 || secondPop_int >= 30) {
            this.popText = '未来两小时有雨'
          } else {
            this.popText = '未来两小时没有雨'
          }
        }
      })
    },
    // 天气图标
    getWeatherIconByCode(code) {
      return require(`/static/color-64/${code}.png`)
    },
    // 逐天天气的日期描述
    getDayTitle(index) {
      if (index == 0) {
        return '今天'
      }
      if (index == 1) {
        return '明天'
      }
      if (index == 2) {
        return '后天'
      }
    },
    // 空气质量级别颜色
    getLevelColor(aqi) {
      const aqi_int = parseInt(aqi)
      if (aqi_int <= 50) { // 优
        return '#00FF00'
      } else if (aqi_int <= 100) { // 良
        return '#FFFF00'
      } else if (aqi_int <= 150) { // 轻度污染
        return '#FFA500'
      } else if (aqi_int <= 200) { // 中度污染
        return '#FF0000'
      } else if (aqi_int <= 300) { // 重度污染
        return '#800080'
      } else { // 严重污染
        return '#8B0000'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.root-container {
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
}
.weather-wrap {
  display: flex;
  flex-direction: column;
  padding: 8px;
  height: 300px;
  background-image: url("../../static/img/weather_bg_small.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  span {
    font-size: 14px;
    color: white;
  }
  .top-wrap {
    margin: 0 20px;
    display: flex;
    flex: 1;
    flex-direction: column;
    .city-name {
      color: white;
      font-size: 15px;
      text-align: left;
    }
    .info {
      display: flex;
      align-items: center;
      margin-top: 20px;
      .temp {
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        span:nth-of-type(1) {
          font-size: 20px;
        }
        span:nth-of-type(2) {
          font-size: 14px;
          margin-top: 6px;
        }
      }
      .warning {
        display: flex;
        flex-direction: column;
        margin-left: auto;
        align-items: flex-end;
        .type-name {
          border-radius: 16px;
          background: orange;
          padding: 2px 12px;
        }
        .aqi-name {
          margin-top: 4px;
        }
      }
    }
    .tip {
      margin-top: 20px;
      text-align: left;
    }
  }
  .bottom-wrap {
    display: flex;
    flex: 1;
    margin: 0 20px;
    align-items: center;
    .item {
      display: flex;
      flex: 1;
      flex-direction: column;
      span:nth-of-type(1) {
        margin-bottom: 4px;
      }
      span:nth-of-type(2) {
        margin-top: 4px;
        margin-bottom: 4px;
      }
    }
  }
  .line {
    height: 1px;
    background: #e1e1e1;
  }
}
.news-wrap {
  background: white;
  margin-top: 30px;
  border-radius: 8px;
  padding: 8px 16px;
  text-align: left;
  span {
    font-size: 14px;
  }
  .title {
    font-size: 16px;
  }
  .item {
    padding: 12px 0;
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f5f5f5;
    .title {
      flex: 1;
      margin-right: 12px;
    }
  }
}
</style>
